module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABDBAMAAACYZb3pAAAAHlBMVEXOESbzrxj90RaWuTQAlGDOESb2thj80RaPtzYAlGAlG+OSAAAACXRSTlPUrNSs1P/G/8YgTiD5AAAAMUlEQVR4AWJkQAOMimgCQgLoKkIB7csxDQAAAAIg+6c2g6+DH0VRFEVRlN+iKIqSuRS1jSelBbrG1gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/gn.png
// module id = KzEt
// module chunks = 0